import React from "react";
import "./HealthTwoCategory.scss";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";
import { useNavigate } from "react-router-dom";

const HealthTwoCategories = () => {
  const { documents } = useCollection("m_categories");
  const navigate = useNavigate();

  const categories = documents
    ? documents.filter((doc) => doc.status === "active").slice(0, 6)
    : [];

  const backgroundColors = [
    "#b2ebf2",
    "#ffb74d",
    "#c5e1a5",
    "#e1bee7",
    "#ffd54f",
    "#f8bbd0",
  ];

  return (
    <div className="health-two-categories">
      <h2 className="health-two-section-heading">Shop by Health Concern</h2>
      <div className="category-list">
        {categories.map((item, index) => (
          <div
            className="category-card"
            key={index}
            style={{
              backgroundColor: backgroundColors[index % backgroundColors.length],
              cursor: "pointer",
            }}
            onClick={() =>
              navigate(`/products?category=${encodeURIComponent(item.category)}`)
            }
          >
            <img src={item.categoryImgUrl} alt={item.category} />
            <p>{item.category}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HealthTwoCategories;
